<template>
  <div class="template-view-contract">
    <section class="contract-section">
      <h4 class="contract-section-title">Estudante</h4>

      <div class="contract-card" v-if="formEnroll.EnrollmentStudent">
        <div class="contract-body">
          <img
            :src="photoSrc(
              formEnroll.EnrollmentStudent &&
                formEnroll.EnrollmentStudent.photo
            )"
            class="contract-avatar"
            :alt="
              (formEnroll.EnrollmentStudent &&
                formEnroll.EnrollmentStudent.name) ||
              'Foto do estudante'
            "
            @error="onImageError"
          />

          <div class="contract-fields">
            <div class="contract-field">
              <span class="contract-field-label">Nome</span>
              <span class="contract-field-value">{{
                formEnroll.EnrollmentStudent.name
              }}</span>
            </div>
            <div class="contract-field">
              <span class="contract-field-label">Data de nascimento</span>
              <span class="contract-field-value">{{
                formEnroll.EnrollmentStudent.birth_date | formatDate
              }}</span>
            </div>
            <div class="contract-field">
              <span class="contract-field-label">Sexo</span>
              <span class="contract-field-value">{{
                formEnroll.EnrollmentStudent.gender
              }}</span>
            </div>
            <div class="contract-field">
              <span class="contract-field-label">Cor</span>
              <span class="contract-field-value">{{
                formEnroll.EnrollmentStudent.skin_color
              }}</span>
            </div>

            <template v-if="!gradeName">
              <div class="contract-field contract-field--wide">
                <span class="contract-field-label">Ciclo</span>
                <span class="contract-field-value">{{
                  formEnroll.EnrollmentStudent.cycle_name
                }}</span>
              </div>
              <div
                class="contract-field"
                v-if="formEnroll.EnrollmentStudent.grade !== 'B1_8'"
              >
                <span class="contract-field-label">Ano</span>
                <span class="contract-field-value">{{
                  formEnroll.EnrollmentStudent.year_id
                }}</span>
              </div>
            </template>
            <template v-else>
              <div class="contract-field contract-field--wide">
                <span class="contract-field-label">Ciclo</span>
                <span class="contract-field-value">{{ gradeName }}</span>
              </div>
              <div
                class="contract-field"
                v-if="
                  !(
                    rdaUnit === 'BELO_HORIZONTE' &&
                    formEnroll.EnrollmentStudent.grade === 'B1_8'
                  )
                "
              >
                <span class="contract-field-label">Turno</span>
                <span class="contract-field-value">
                  {{
                    rdaUnit === "POUSO_ALEGRE" &&
                    formEnroll.EnrollmentStudent.grade === "B1_8"
                      ? "Manhã"
                      : formEnroll.EnrollmentStudent.time_period === "Matutino"
                      ? "Manhã"
                      : "Tarde"
                  }}
                </span>
              </div>
            </template>

            <div class="contract-field">
              <span class="contract-field-label">Guarda</span>
              <span class="contract-field-value">{{
                String(formEnroll.EnrollmentStudent.guardian).toUpperCase()
              }}</span>
            </div>
            <div
              class="contract-field contract-field--wide"
              v-if="formEnroll.EnrollmentStudent.previous_school"
            >
              <span class="contract-field-label">Escola anterior</span>
              <span class="contract-field-value">{{
                formEnroll.EnrollmentStudent.previous_school
              }}</span>
            </div>

            <template v-if="formEnroll.EnrollmentStudent.Address">
              <span class="contract-fields-group">Endereço</span>
              <div class="contract-field contract-field--wide">
                <span class="contract-field-label">Rua</span>
                <span class="contract-field-value">{{
                  formEnroll.EnrollmentStudent.Address.street
                }}</span>
              </div>
              <div class="contract-field">
                <span class="contract-field-label">Número</span>
                <span class="contract-field-value">{{
                  formEnroll.EnrollmentStudent.Address.number
                }}</span>
              </div>
              <div class="contract-field">
                <span class="contract-field-label">Bairro</span>
                <span class="contract-field-value">{{
                  formEnroll.EnrollmentStudent.Address.neighborhood
                }}</span>
              </div>
              <div class="contract-field">
                <span class="contract-field-label">Cidade</span>
                <span class="contract-field-value">{{
                  formEnroll.EnrollmentStudent.Address.city
                }}</span>
              </div>
              <div class="contract-field contract-field--wide">
                <span class="contract-field-label">Complemento</span>
                <span class="contract-field-value">{{
                  formEnroll.EnrollmentStudent.Address.complement
                }}</span>
              </div>
              <div class="contract-field">
                <span class="contract-field-label">CEP</span>
                <span class="contract-field-value">{{
                  formEnroll.EnrollmentStudent.Address.cep ||
                  "Não disponível"
                }}</span>
              </div>
              <span class="contract-fields-group">Contato</span>
              <div class="contract-field">
                <span class="contract-field-label">Telefone 1</span>
                <span class="contract-field-value">{{
                  formEnroll.EnrollmentStudent.phone1
                }}</span>
              </div>
              <div
                class="contract-field"
                v-if="formEnroll.EnrollmentStudent.phone2"
              >
                <span class="contract-field-label">Telefone 2</span>
                <span class="contract-field-value">{{
                  formEnroll.EnrollmentStudent.phone2
                }}</span>
              </div>
              <div class="contract-field contract-field--wide">
                <span class="contract-field-label">Email</span>
                <span class="contract-field-value">{{
                  formEnroll.EnrollmentStudent.email
                }}</span>
              </div>
            </template>

            <span class="contract-fields-group">Documentos</span>
            <div class="contract-field contract-field--wide">
              <span class="contract-field-label">Certidão</span>
              <span class="contract-field-value">{{
                formEnroll.EnrollmentStudent.birth_certificate
              }}</span>
            </div>
            <div class="contract-field">
              <span class="contract-field-label">CPF</span>
              <span class="contract-field-value">{{
                formEnroll.EnrollmentStudent.cpf
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="contract-section">
      <h4 class="contract-section-title">Contratante(s)</h4>

      <div class="contract-card">
        <div
          v-for="(contractor, index) in formEnroll.Contractor"
          :key="`${contractor.id}-${index}-contractor`"
          class="contract-entity"
        >
          <span class="contract-entity-header"
            >{{ contractor.type }} - {{ contractor.relationship }}</span
          >

          <div class="contract-body">
            <img
              :src="photoSrc(contractor.photo)"
              class="contract-avatar"
              :alt="contractor.name || 'Foto do contratante'"
              @error="onImageError"
            />

            <div class="contract-fields">
              <div class="contract-field">
                <span class="contract-field-label">Nome</span>
                <span class="contract-field-value">{{
                  contractor.name
                }}</span>
              </div>
              <div class="contract-field">
                <span class="contract-field-label">Data de nascimento</span>
                <span class="contract-field-value">{{
                  contractor.birth_date | formatDate
                }}</span>
              </div>
              <div class="contract-field">
                <span class="contract-field-label">Ocupação</span>
                <span class="contract-field-value">{{
                  contractor.occupation
                }}</span>
              </div>
              <div class="contract-field">
                <span class="contract-field-label">Local</span>
                <span class="contract-field-value">{{
                  contractor.workplace
                }}</span>
              </div>
              <div class="contract-field" v-if="contractor.talents">
                <span class="contract-field-label">Atividade</span>
                <span class="contract-field-value">{{
                  contractor.talents
                }}</span>
              </div>
              <div class="contract-field">
                <span class="contract-field-label">Guarda</span>
                <span class="contract-field-value">{{
                  contractor.is_guardian ? "Sim" : "Não"
                }}</span>
              </div>

              <template v-if="contractor.Address">
                <span class="contract-fields-group">Endereço</span>
                <div class="contract-field contract-field--wide">
                  <span class="contract-field-label">Rua</span>
                  <span class="contract-field-value">{{
                    contractor.Address.street
                  }}</span>
                </div>
                <div class="contract-field">
                  <span class="contract-field-label">Número</span>
                  <span class="contract-field-value">{{
                    contractor.Address.number
                  }}</span>
                </div>
                <div class="contract-field">
                  <span class="contract-field-label">Bairro</span>
                  <span class="contract-field-value">{{
                    contractor.Address.neighborhood
                  }}</span>
                </div>
                <div class="contract-field">
                  <span class="contract-field-label">Cidade</span>
                  <span class="contract-field-value">{{
                    contractor.Address.city
                  }}</span>
                </div>
                <div class="contract-field contract-field--wide">
                  <span class="contract-field-label">Complemento</span>
                  <span class="contract-field-value">{{
                    contractor.Address.complement
                  }}</span>
                </div>
                <div class="contract-field">
                  <span class="contract-field-label">CEP</span>
                  <span class="contract-field-value">{{
                    contractor.Address.cep
                      ? contractor.Address.cep
                      : "Não disponível"
                  }}</span>
                </div>

                <span class="contract-fields-group">Contato</span>
                <div class="contract-field">
                  <span class="contract-field-label">Telefone 1</span>
                  <span class="contract-field-value">{{
                    contractor.phone1
                  }}</span>
                </div>
                <div class="contract-field" v-if="contractor.phone2">
                  <span class="contract-field-label">Telefone 2</span>
                  <span class="contract-field-value">{{
                    contractor.phone2
                  }}</span>
                </div>
                <div class="contract-field contract-field--wide">
                  <span class="contract-field-label">Email</span>
                  <span class="contract-field-value">{{
                    contractor.email
                  }}</span>
                </div>
              </template>

              <span class="contract-fields-group">Documentos</span>
              <div class="contract-field">
                <span class="contract-field-label">CPF</span>
                <span class="contract-field-value">{{
                  contractor.cpf
                }}</span>
              </div>
              <div class="contract-field">
                <span class="contract-field-label"
                  >Contato prioritário assuntos financeiros</span
                >
                <span class="contract-field-value">{{
                  contractor.is_financial_contact | booleanString
                }}</span>
              </div>
              <div class="contract-field">
                <span class="contract-field-label"
                  >Contato prioritário assuntos pedagógicos</span
                >
                <span class="contract-field-value">{{
                  contractor.is_pedagogical_contact | booleanString
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="contract-section">
      <h4 class="contract-section-title">Filiação</h4>

      <div class="contract-card">
        <div
          v-for="(filiation, index) in visibleFiliations"
          :key="`${filiation.id}-${index}-filiation`"
          class="contract-entity"
        >
          <span class="contract-entity-header"
            >{{ filiation.typeLabel }} - {{ filiation.subtitle }}</span
          >

          <div class="contract-body">
            <img
              v-if="!filiation.hasNoDetails"
              :src="photoSrc(filiation.photo)"
              class="contract-avatar"
              :alt="filiation.name || 'Foto da filiação'"
              @error="onImageError"
            />

            <div class="contract-fields">
              <div class="contract-field" v-if="filiation.hasName">
                <span class="contract-field-label">Nome</span>
                <span class="contract-field-value">{{
                  filiation.name
                }}</span>
              </div>

              <template v-if="!filiation.hasNoDetails">
                <div class="contract-field">
                  <span class="contract-field-label">Ocupação</span>
                  <span class="contract-field-value">{{
                    filiation.occupation
                  }}</span>
                </div>
                <div class="contract-field">
                  <span class="contract-field-label">Local</span>
                  <span class="contract-field-value">{{
                    filiation.workplace
                  }}</span>
                </div>
                <div class="contract-field" v-if="filiation.talents">
                  <span class="contract-field-label">Atividade</span>
                  <span class="contract-field-value">{{
                    filiation.talents
                  }}</span>
                </div>
              </template>

              <template v-if="filiation.Address && !filiation.hasNoDetails">
                <span class="contract-fields-group">Endereço</span>
                <div class="contract-field contract-field--wide">
                  <span class="contract-field-label">Rua</span>
                  <span class="contract-field-value">{{
                    filiation.Address.street
                  }}</span>
                </div>
                <div class="contract-field">
                  <span class="contract-field-label">Número</span>
                  <span class="contract-field-value">{{
                    filiation.Address.number
                  }}</span>
                </div>
                <div class="contract-field">
                  <span class="contract-field-label">Bairro</span>
                  <span class="contract-field-value">{{
                    filiation.Address.neighborhood
                  }}</span>
                </div>
                <div class="contract-field">
                  <span class="contract-field-label">Cidade</span>
                  <span class="contract-field-value">{{
                    filiation.Address.city
                  }}</span>
                </div>
                <div class="contract-field contract-field--wide">
                  <span class="contract-field-label">Complemento</span>
                  <span class="contract-field-value">{{
                    filiation.Address.complement
                  }}</span>
                </div>
                <div class="contract-field">
                  <span class="contract-field-label">CEP</span>
                  <span class="contract-field-value">{{
                    filiation.Address.cep
                      ? filiation.Address.cep
                      : "Não disponível"
                  }}</span>
                </div>

                <span class="contract-fields-group">Contato</span>
                <div class="contract-field">
                  <span class="contract-field-label">Telefone 1</span>
                  <span class="contract-field-value">{{
                    filiation.phone1
                  }}</span>
                </div>
                <div class="contract-field" v-if="filiation.phone2">
                  <span class="contract-field-label">Telefone 2</span>
                  <span class="contract-field-value">{{
                    filiation.phone2
                  }}</span>
                </div>
                <div class="contract-field contract-field--wide">
                  <span class="contract-field-label">Email</span>
                  <span class="contract-field-value">{{
                    filiation.email
                  }}</span>
                </div>
              </template>

              <template v-if="!filiation.hasNoDetails">
                <span class="contract-fields-group">Documentos</span>
                <div class="contract-field">
                  <span class="contract-field-label">CPF</span>
                  <span class="contract-field-value">{{
                    filiation.cpf
                  }}</span>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      class="contract-section"
      v-if="formEnroll.EnrollmentComplement"
    >
      <template v-if="formEnroll.EnrollmentComplement !== undefined">
        <h4 class="contract-section-title">Informações complementares</h4>

        <div class="contract-card contract-card-split">
          <div class="contract-fields contract-fields-stacked">
            <div class="contract-field">
              <span class="contract-field-label"
                >As vacinas estão em dia a data presente?</span
              >
              <span class="contract-field-value">{{
                formEnroll.EnrollmentComplement.vaccines_up_to_date
                  | booleanString
              }}</span>
            </div>
            <div class="contract-field">
              <span class="contract-field-label"
                >O aluno possui alguma restrição alimentar?</span
              >
              <span class="contract-field-value">
                {{
                  formEnroll.EnrollmentComplement.food_restriction
                    | booleanString
                }}
                <template
                  v-if="formEnroll.EnrollmentComplement.food_restriction"
                >
                  ,
                  {{
                    formEnroll.EnrollmentComplement
                      .food_restriction_description
                  }}
                </template>
              </span>
            </div>
            <div class="contract-field">
              <span class="contract-field-label"
                >O aluno possui algum problema crônico?</span
              >
              <span class="contract-field-value">
                {{
                  formEnroll.EnrollmentComplement.health_problem
                    | booleanString
                }}
                <template
                  v-if="formEnroll.EnrollmentComplement.health_problem"
                >
                  ,
                  {{
                    formEnroll.EnrollmentComplement.health_problem_description
                  }}
                </template>
              </span>
            </div>
            <div class="contract-field">
              <span class="contract-field-label">Tem alguma limitação?</span>
              <span class="contract-field-value">
                {{ formEnroll.EnrollmentComplement.limitation | booleanString }}
                <template v-if="formEnroll.EnrollmentComplement.limitation">
                  ,
                  {{ formEnroll.EnrollmentComplement.limitation_description }}
                </template>
              </span>
            </div>
            <div class="contract-field">
              <span class="contract-field-label"
                >O aluno tem algum acompanhamento especializado?</span
              >
              <span class="contract-field-value">
                {{
                  formEnroll.EnrollmentComplement.special_accompaniment
                    | booleanString
                }}
                <template
                  v-if="
                    formEnroll.EnrollmentComplement.special_accompaniment
                  "
                >
                  ,
                  {{
                    formEnroll.EnrollmentComplement
                      .special_accompaniment_description
                  }}
                </template>
              </span>
            </div>
            <div class="contract-field">
              <span class="contract-field-label"
                >O aluno necessita de algum cuidado especial por motivos de
                saúde?</span
              >
              <span class="contract-field-value">
                {{
                  formEnroll.EnrollmentComplement.special_care | booleanString
                }}
                <template v-if="formEnroll.EnrollmentComplement.special_care">
                  ,
                  {{
                    formEnroll.EnrollmentComplement.special_care_description
                  }}
                </template>
              </span>
            </div>
            <div class="contract-field">
              <span class="contract-field-label"
                >O aluno possui algum convênio médico?</span
              >
              <span class="contract-field-value">
                {{
                  formEnroll.EnrollmentComplement.healthcare | booleanString
                }}
                <template v-if="formEnroll.EnrollmentComplement.healthcare">
                  ,
                  {{ formEnroll.EnrollmentComplement.healthcare_description }}
                </template>
              </span>
            </div>
          </div>

          <div class="contract-fields contract-fields-stacked">
            <h5 class="contract-subtitle">
              Em caso de emergência, não sendo localizados os responsáveis,
              entrar em contato com:
            </h5>

            <div class="contract-field">
              <span class="contract-field-label">Nome</span>
              <span class="contract-field-value">{{
                formEnroll.EnrollmentComplement.contact1
              }}</span>
            </div>
            <div class="contract-field">
              <span class="contract-field-label">Telefone</span>
              <span class="contract-field-value">{{
                formEnroll.EnrollmentComplement.contact1_phone
              }}</span>
            </div>
            <div class="contract-field">
              <span class="contract-field-label">Nome</span>
              <span class="contract-field-value">{{
                formEnroll.EnrollmentComplement.contact2
              }}</span>
            </div>
            <div class="contract-field">
              <span class="contract-field-label">Telefone</span>
              <span class="contract-field-value">{{
                formEnroll.EnrollmentComplement.contact2_phone
              }}</span>
            </div>
            <div class="contract-field">
              <span class="contract-field-label"
                >Forma como o aluno retornará a sua residência</span
              >
              <span class="contract-field-value">{{
                formEnroll.EnrollmentComplement.return_to_home
              }}</span>
            </div>

            <template
              v-if="
                formEnroll.EnrollmentComplement.return_to_home != 'Sozinho'
              "
            >
              <h5 class="contract-subtitle">
                Pessoas autorizadas a acompanhar o(a) aluno(a) na saída:
              </h5>

              <div class="contract-contact-list">
                <div
                  v-for="(contact, index) of formEnroll.EnrollmentComplement
                    .EnrollmentComplementContacts"
                  :key="`${contact.id}-${index}`"
                  class="contract-contact-card"
                >
                  <img
                    :src="photoSrc(contact.photo)"
                    class="contract-contact-avatar"
                    :alt="contact.name || 'Foto do contato'"
                    @error="onImageError"
                  />

                  <div class="contract-fields">
                    <span class="contract-fields-group"
                      >{{ index + 1 }}° pessoa</span
                    >
                    <div class="contract-field">
                      <span class="contract-field-label">Nome</span>
                      <span class="contract-field-value">{{
                        contact.name
                      }}</span>
                    </div>
                    <div class="contract-field">
                      <span class="contract-field-label"
                        >Relação com aluno</span
                      >
                      <span class="contract-field-value">{{
                        contact.relationship
                      }}</span>
                    </div>
                    <div class="contract-field">
                      <span class="contract-field-label">Telefone 1</span>
                      <span class="contract-field-value">{{
                        contact.number1
                      }}</span>
                    </div>
                    <div class="contract-field" v-if="contact.number2">
                      <span class="contract-field-label">Telefone 2</span>
                      <span class="contract-field-value">{{
                        contact.number2
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>
    </section>

    <section
      class="contract-section"
      v-if="formEnroll.EnrollmentAuthorization"
    >
      <template v-if="formEnroll.EnrollmentAuthorization !== undefined">
        <h4 class="contract-section-title">Autorizações</h4>

        <div class="contract-card">
          <div class="contract-auth-list">
            <div
              v-for="([key, value], index) in Object.entries(
                filteredAuthorizations
              ).filter(([k]) => texts[k])"
              :key="key"
              class="contract-auth-item"
            >
              <span class="contract-auth-index">{{ index + 1 }}</span>
              <span class="contract-auth-text">{{ texts[key] }}</span>
              <span
                class="contract-pill"
                :class="
                  value === true || value === 'Sim' || value === 'yes'
                    ? 'is-yes'
                    : 'is-no'
                "
                >{{ value | booleanString }}</span
              >
            </div>
          </div>
        </div>
      </template>
    </section>
  </div>
</template>

<script>
import moment from "moment";

const FILIATION_NO_DETAILS_EMAIL = "not_applicable@notapplicable.com";
const FILIATION_NOT_APPLICABLE_NAME = "Not Applicable";

export default {
  props: {
    showMessage: {
      type: Boolean,
      default: true,
    },
    formEnroll: {
      type: Object,
    },
    gradeName: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      rdaUnit: process.env.VUE_APP_RDA_UNIT,
      emCycles: [4, 5],
      leaveLunchCycles: [3, 10],
      fundamentalCycles: [1, 2, 3, 9, 10],
      texts: {
        excursion:
          "Fica o aluno antecipadamente autorizado, independentemente de permissão específica, a participar de excursões — parte integrante do projeto pedagógico desta escola — desde que realizadas dentro do horário normal de aulas e dentro dos limites do município.",
        shower:
          "Fica o aluno autorizado a tomar banho de ducha/mangueira independentemente de autorização específica.",
        leave_school_break:
          "Fica o aluno, matriculado no Ensino Médio, autorizado a sair desacompanhado das dependências da Escola da Serra durante o horário de recreio.",
      },
    };
  },

  computed: {
    enrollment_id() {
      return this.$route.params.id;
    },
    currentCycle() {
      return (
        this.formEnroll.EnrollmentStudent &&
        this.formEnroll.EnrollmentStudent.cycle_id
      );
    },
    filteredAuthorizations() {
      if (!this.formEnroll.EnrollmentAuthorization) {
        return {};
      }
      let auth = { ...this.formEnroll.EnrollmentAuthorization };

      delete auth.leave_school_antecipated;
      delete auth.leave_school_lunch;

      if (
        this.rdaUnit === "POUSO_ALEGRE" ||
        !this.emCycles.includes(this.currentCycle)
      ) {
        delete auth.leave_school_break;
      }

      return auth;
    },
    visibleFiliations() {
      if (!this.formEnroll.Filiation) {
        return [];
      }

      return this.formEnroll.Filiation
        .filter(
          (filiation) => filiation.name !== FILIATION_NOT_APPLICABLE_NAME
        )
        .map((filiation) => {
          const hasNoDetails = filiation.email === FILIATION_NO_DETAILS_EMAIL;
          const isNotApplicable = hasNoDetails && filiation.name === "Não Há";
          const types = (filiation.ResponsibleTypes || []).map(
            (responsibleType) => responsibleType.type
          );

          return {
            ...filiation,
            hasNoDetails,
            hasName: !isNotApplicable,
            typeLabel: [
              types.includes("filiation a") ? "Filiação A" : "",
              types.includes("filiation b") ? "Filiação B" : "",
            ]
              .filter(Boolean)
              .join(" "),
            subtitle: isNotApplicable
              ? "Não há"
              : `${filiation.relationship}${
                  hasNoDetails ? " - Falecido(a)" : ""
                }`,
          };
        });
    },
  },
  methods: {
    isValidPhoto(photo) {
      return typeof photo === "string" && photo.trim() !== "";
    },

    photoSrc(photo) {
      return this.isValidPhoto(photo)
        ? photo
        : require("../../assets/images/default-user.png");
    },

    onImageError(event) {
      if (event.target.dataset.fallbackApplied) {
        return;
      }

      event.target.dataset.fallbackApplied = "true";
      event.target.src = require("../../assets/images/default-user.png");
    },
  },

  filters: {
    booleanString(str) {
      if (str === true || str === "Sim" || str === "yes") return "Sim";
      else if (str === false || str === "Não" || str === "no") return "Não";
      else if (str === "na") return "Não se aplica";
      else return str;
    },
    formatDate(dateToBeFormatted) {
      return moment(dateToBeFormatted).format("DD/MM/YYYY");
    },
  },
};
</script>

<style lang="scss">
h4 {
  text-transform: uppercase;
}
.user-highlight {
  width: 100%;
  border-bottom: 2px solid #fafafa;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  padding-bottom: 20px;
  margin-bottom: 20px;

  p {
    margin-bottom: 0;
    text-align: justify;
  }
}
.box {
  background: #fff;
  padding: 30px;
  margin-bottom: 60px;
  border-radius: 10px;
  box-shadow: 0 5px 7px rgba(0, 0, 0, 0.1);

  .box-item {
    &:last-of-type {
      border: 0;
      margin-bottom: 0;
      padding-bottom: 0;
    }
  }
}
.box-item {
  border-bottom: 4px solid #fafafa;
  margin-bottom: 20px;
  padding-bottom: 20px;
}
.image-rounded {
  width: 150px;
  border-radius: 50%;
}
.strong_padding {
  padding-left: 16px;
}
.box {
  text-align: justify;
}
.student-card {
  row-gap: 12px;
  column-gap: 0;
}
.wrap {
  word-break: break-word;
  overflow-wrap: anywhere;
}
.image-rounded {
  width: 150px;
  height: 150px;
  object-fit: cover;
  border-radius: 50%;
}

</style>

<style lang="scss" scoped>
.template-view-contract {
  --contract-border: #e7e4ec;
  --contract-heading: #35303d;
  --contract-label: #716b79;
  --contract-muted: #f8f7fa;
  --contract-accent-soft: #f2edf6;
  --contract-accent: #6d3e91;

  color: var(--contract-heading);

  .contract-section {
    margin-bottom: 36px;
  }

  .contract-section-title {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 0 0 14px;
    color: var(--contract-accent);
    font-size: 0.94rem;
    font-weight: 700;
    letter-spacing: 0.06em;

    &::after {
      content: "";
      height: 1px;
      background: var(--contract-border);
      flex: 1;
    }
  }

  .contract-card {
    background: #fff;
    padding: 20px;
    border: 1px solid var(--contract-border);
    border-top: 3px solid var(--contract-accent);
    border-radius: 10px;
    box-shadow: 0 6px 20px rgba(53, 48, 61, 0.06);
    text-align: left;
  }

  .contract-card-split {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 40px;
  }

  .contract-entity + .contract-entity {
    margin-top: 24px;
    padding-top: 24px;
    border-top: 1px solid var(--contract-border);
  }

  .contract-entity-header {
    display: flex;
    width: 100%;
    margin: 0 0 20px;
    padding: 10px 14px;
    border-radius: 6px;
    background: var(--contract-accent-soft);
    color: var(--contract-accent);
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.03em;
    text-transform: uppercase;
  }

  .contract-body {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
  }

  .contract-avatar {
    width: 124px;
    height: 124px;
    min-width: 124px;
    padding: 4px;
    border: 2px solid var(--contract-accent-soft);
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 3px 12px rgba(53, 48, 61, 0.08);
    object-fit: cover;
  }

  .contract-fields {
    display: grid;
    flex: 1;
    min-width: 220px;
    grid-template-columns: repeat(12, minmax(0, 1fr));
    gap: 12px;
    align-content: start;
  }

  .contract-fields-stacked {
    grid-template-columns: 1fr;
    gap: 16px;

    .contract-field {
      grid-column: 1 / -1;
    }
  }

  .contract-fields-group {
    grid-column: 1 / -1;
    margin-top: 10px;
    padding: 8px 12px;
    border-radius: 6px;
    background: var(--contract-accent-soft);
    color: var(--contract-accent);
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .contract-field {
    display: flex;
    min-width: 0;
    min-height: 72px;
    flex-direction: column;
    justify-content: center;
    gap: 5px;
    grid-column: span 4;
    padding: 11px 13px;
    border: 1px solid var(--contract-border);
    border-radius: 7px;
    background: var(--contract-muted);
  }

  .contract-field--wide {
    grid-column: span 8;
  }

  .contract-field-label {
    color: var(--contract-label);
    font-size: 0.69rem;
    font-weight: 600;
    letter-spacing: 0.02em;
    line-height: 1.35;
    text-transform: uppercase;
  }

  .contract-field-value {
    color: var(--contract-heading);
    font-size: 0.9rem;
    font-weight: 600;
    line-height: 1.4;
    overflow-wrap: break-word;
    word-break: normal;
  }

  .contract-subtitle {
    margin: 4px 0 2px;
    padding-bottom: 8px;
    border-bottom: 1px solid var(--contract-border);
    color: var(--contract-heading);
    font-size: 0.76rem;
    line-height: 1.45;
  }

  .contract-contact-list {
    display: grid;
    grid-column: 1 / -1;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 12px;
  }

  .contract-contact-card {
    padding: 14px;
    border: 1px solid var(--contract-border);
    border-radius: 6px;
    background: var(--contract-muted);
    display: flex;
    gap: 14px;

    .contract-field {
      grid-column: 1 / -1;
      min-height: auto;
      padding: 6px 8px;
      border: 0;
      background: #fff;
    }
  }

  .contract-contact-avatar {
    width: 56px;
    height: 56px;
    min-width: 56px;
    border: 1px solid var(--contract-border);
    border-radius: 6px;
    background: var(--contract-muted);
    object-fit: cover;
  }

  .contract-auth-list {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  .contract-auth-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px 0;
    border-radius: 0;
    border-bottom: 1px solid var(--contract-border);
    background: transparent;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      padding-bottom: 0;
      border-bottom: 0;
    }
  }

  .contract-auth-index {
    width: 24px;
    height: 24px;
    min-width: 24px;
    border: 1px solid var(--contract-border);
    background: var(--contract-muted);
    color: var(--contract-accent);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.8rem;
    font-weight: 700;
  }

  .contract-auth-text {
    flex: 1;
    color: var(--contract-heading);
    font-size: 0.86rem;
    line-height: 1.5;
    text-align: left;
  }

  .contract-pill {
    flex-shrink: 0;
    min-width: 48px;
    padding: 5px 10px;
    border: 1px solid var(--contract-border);
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 700;
    text-align: center;
    text-transform: uppercase;

    &.is-yes {
      border-color: #b9d9c4;
      background: #eef8f1;
      color: #28643b;
    }

    &.is-no {
      background: var(--contract-muted);
      color: var(--contract-label);
    }
  }

  @media (max-width: 991px) {
    .contract-fields {
      grid-template-columns: repeat(6, minmax(0, 1fr));
    }

    .contract-field {
      grid-column: span 3;
    }

    .contract-field--wide {
      grid-column: 1 / -1;
    }
  }

  @media (max-width: 600px) {
    .contract-section {
      margin-bottom: 28px;
    }

    .contract-card {
      padding: 18px;
    }

    .contract-body {
      flex-direction: column;
      gap: 18px;
    }

    .contract-avatar {
      width: 88px;
      height: 88px;
      min-width: 88px;
    }

    .contract-fields {
      width: 100%;
      min-width: 0;
      grid-template-columns: 1fr;
    }

    .contract-field,
    .contract-field--wide {
      grid-column: 1 / -1;
    }

    .contract-auth-item {
      align-items: flex-start;
    }
  }

  @media print {
    .contract-section,
    .contract-entity,
    .contract-contact-card,
    .contract-auth-item {
      break-inside: avoid;
    }

    .contract-card {
      padding: 18px;
      box-shadow: none;
    }
  }
}
</style>
